import { render } from "./CreateEmployeeGatepass.vue?vue&type=template&id=2749d74e&scoped=true"
import script from "./CreateEmployeeGatepass.vue?vue&type=script&lang=js"
export * from "./CreateEmployeeGatepass.vue?vue&type=script&lang=js"

import "./CreateEmployeeGatepass.vue?vue&type=style&index=0&id=2749d74e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2749d74e"]])

export default __exports__